import React from 'react';
import { arrayOf, bool, string } from 'prop-types';
import { BulletList } from './BulletList';

export const Highlights = ({ highlights, hideRichContents }) => {
  // @TODO dont map highlight to value:
  const highlightedBullets = (highlights || []).map((highlight) => ({ value: highlight }));
  if (!highlightedBullets.length) {
    return null;
  }

  return (
    <BulletList
      bullets={highlightedBullets}
      hideRichContents={hideRichContents}
    />

  );
};

Highlights.displayName = 'ProductOverviewHighlights';

Highlights.propTypes = {
  highlights: arrayOf(string).isRequired,
  hideRichContents: bool
};

Highlights.defaultProps = {
  hideRichContents: false
};
